import React from 'react';

import CreateEventForm from '../components/CreateEventForm';
import { isDev, isLocalDev } from '@/utils/isDev';
import i18n from '@/utils/i18n';

export const CreateEventPage: React.FC = () => {
  const isDevelopmentEnv = isDev() || isLocalDev();

  if (!isDevelopmentEnv) {
    return <div>{i18n.t('Events:createEventsInZohoCRM')}</div>;
  }

  return <CreateEventForm />;
};
